@if (isInfoNavigation) {
  <button
    [matTooltip]="tooltipText ? (tooltipText | translate) : ''"
    matTooltipPosition="above"
    [matTooltipDisabled]="isMobile"
    class="header-icon-container clear-button"
    routerLink="info"
    type="button">
    <img alt="" aria-hidden="true" class="header-img"
      loading="lazy" src="assets/scalableVectorGraphics/info-bold.svg" style="transform: translateY(-0.2rem);" />
      <span aria-hidden="false" class="sr-only">{{ 'shared.learnMore' | translate }}</span>
    </button>
  }

  @if (!isInfoNavigation) {
    <button (click)="onInfoButtonToggle()"
      [matTooltip]="tooltipText ? (tooltipText | translate) : ''"
      matTooltipPosition="above"
      [matTooltipDisabled]="isMobile"
      class="header-icon-container clear-button"
      type="button">
      <img alt="" aria-hidden="true" class="header-img"
        loading="lazy" src="assets/scalableVectorGraphics/info-bold.svg" style="transform: translateY(-0.2rem);" />
        <span aria-hidden="false" class="sr-only">{{ 'shared.learnMore' | translate }}</span>
      </button>
    }


